import _ from 'lodash'
import originalSchemas from '../../dist/allOriginalSchemas.json'

const schemas = _.mapKeys(originalSchemas, (v, k) => k.replace('.json', ''))

export default {
    ...schemas,
    allComponentsDefinitionsMap: schemas.componentsDefinitionsMap
} as {
    allComponentsDefinitionsMap: Record<string, any>
} & Record<string, any>
